import React, { useContext, useState } from 'react';
import { GlobalContext } from 'providers/GlobalProvider';
import NewHomePageLayout from 'components/Common/Layouts/NewHomePageLayout';
import SearchComp from 'components/Homepage/SearchComp';
import Card from 'components/Automation/Card';
import { tempInfo } from 'components/Automation/NewTempInfo';
import ChatComponent from 'components/Homepage/ChatComponent';
import Tickets from 'components/Homepage/Tickets';
import Modal from 'react-modal';
import { Modal as MUIModal, Grid } from '@mui/material';
import LoginWizard from 'components/Wizard/LoginWizard';
import ModalCommon from 'components/Automation/Modals/ModalCommon';
import MobileAd from 'components/Homepage/MobileAd';
import Updates from 'components/Homepage/Updates';

const NewHomeDashboardPage: React.FC = () => {
  const { cur_user } = useContext(GlobalContext);
  const [ currentIndex, setCurrentIndex ] = useState(0); // Track the current index
  const itemsPerPage = 4; // Number of items to show per 'page'
  const [ isModalOpen, setModalOpen ] = useState(false);
  const [ selectedCard, setSelectedCard ] = useState<{ svgIcon: React.ReactNode; title: string; paragraph: string } | null>(null);
  const [ itemKey, setItemKey ] = useState(0);


  const handleNext = () => {
    // Move to the next set if available
    if (currentIndex <= tempInfo.length) {
      setCurrentIndex((prev) => prev + 2.5);
    }
  };

  const handlePrev = () => {
    // Move to the previous set if available
    if (currentIndex > 0) {
      setCurrentIndex((prev) => prev - 2.5);
    }
  };


  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const helpContent = (
    <p className='module-header-tooltip-text'>
      Quickly search for high risk people, companies and products as well as
      cyber threat indicators. Filter by Lens for more accuracy
    </p>
  );

  return (
    <NewHomePageLayout title={'Dashboard'} helpContent={helpContent} user={cur_user.basics?.firstName}>
      {!cur_user.selected_team && !cur_user.awsUser && (
        <Modal
          isOpen={true}
          ariaHideApp={false}
        >
          <LoginWizard cur_user={cur_user} />
        </Modal>
      )}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div className='activity-cont-frame-left-table-feed-row-cont-divider'></div>
          <SearchComp/>

        </Grid>
        <Grid item xs={12}>
          <div className='templates-first-div'>
            <div className='templates-firs-sub-div'>
              <div className='templates-firs-sub-div-text'>
            Actions
              </div>
              {/* <div className='templates-btn-grp'>

                <div
                  className='templates-btn-grp-subs'
                  onClick={handlePrev}
                  style={{
                    cursor: 'pointer',
                    opacity: currentIndex === 0 ? 0.5 : 1,
                  }}
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='20'
                    height='20'
                    viewBox='0 0 20 20'
                    fill='none'
                  >
                    <path
                      d='M15.8332 10H4.1665M4.1665 10L9.99984 15.8334M4.1665 10L9.99984 4.16669'
                      stroke='#EFF1F6'
                      strokeWidth='1.66667'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </svg>
                </div>

                <div
                  className='templates-btn-grp-sub'
                  onClick={handleNext}
                  style={{
                    cursor: 'pointer',
                    opacity: currentIndex >= tempInfo.length ? 0.5 : 1,
                  }}
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='20'
                    height='20'
                    viewBox='0 0 20 20'
                    fill='none'
                  >
                    <path
                      d='M4.16683 9.99998L15.8335 9.99998M15.8335 9.99998L10.0002 4.16665M15.8335 9.99998L10.0002 15.8333'
                      stroke='#EFF1F6'
                      strokeWidth='1.66667'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </svg>
                </div>
              </div> */}
            </div>
          </div>
        </Grid>
        {tempInfo.map((card, index) => (
          <Grid item xs={6} md={3} key={index}>
            <Card
              key={index}
              title={card.title}
              paragraph={card.paragraph}
              svgIcon={card.svgIcon}
              handleTooltipClick={() => {
                setSelectedCard(card);
                setItemKey(index);
                setModalOpen(true);
              }}
            />
          </Grid>
        ))}

        <Grid item xs={12}>
          {/* <div
            className='templates-sec-div'
            style={{ display: 'flex', overflow: 'hidden' }}
          >
            <div
              style={{
                display: 'flex',
                transform: `translateX(-${((currentIndex / tempInfo.length) * 100)}%)`,
                transition: 'transform 0.5s ease-in-out',
                gap: '10px',
                width: '100%',
                justifyContent: 'space-between'
              }}
            >
              {tempInfo.map((card, index) => (
                <Card
                  key={index}
                  title={card.title}
                  paragraph={card.paragraph}
                  svgIcon={card.svgIcon}
                  handleTooltipClick={() => {
                    setSelectedCard(card);
                    setItemKey(index);
                    setModalOpen(true);
                  }}
                />
              ))}
            </div>
          </div> */}
          <ChatComponent/>
        </Grid>
        <Grid item xs={12} md={6}>
          <Tickets />
        </Grid>
        <Grid item xs={12} md={6}>
          <Updates />
        </Grid>
        {/* <Grid item xs={12}>
          <MobileAd />
        </Grid> */}
      </Grid>

      <MUIModal
        open={isModalOpen}
        onClose={handleCloseModal}
      >
        <div className='modal-overlay'>
          <ModalCommon key={itemKey} svgIcon={selectedCard?.svgIcon} title={selectedCard?.title ?? ''} paragraph={selectedCard?.paragraph ?? ''} handleClose={handleCloseModal} />
        </div>
      </MUIModal>

    </NewHomePageLayout>
  );
};
export default NewHomeDashboardPage;
